// extracted by mini-css-extract-plugin
module.exports = {"promotion-cta":"SectionContentsCta_promotion-cta__3EGju","promotion-cta--outline":"SectionContentsCta_promotion-cta--outline__2nlMq"};